export const base_url = "https://insurance-stc8.onrender.com/"
//"http://localhost:3000/"